<template>
  <div class="arenas-list">
    <div class="form__row">
      <FilterInput title="Filter by name, domain etc"
                   :filterList="arenas"
                   v-on:filter="onFilterArenas"
                   :filterByKey="filterFields"
                   :is-tree="true"
      ></FilterInput>
    </div>

    <div class="loader-wrap" v-if="areArenasLoading">
      <Loader></Loader>
    </div>

    <div class="arenas-list-wrap" v-if="filteredArenas.length && !areArenasLoading">
      <ArenasTree :arenas="filteredArenas" v-on:choseArena="onChooseArena"/>
    </div>
  </div>
</template>

<script>
  import Loader from '../../Loader/Loader.vue'
  import FilterInput from '../../FilterInput/FilterInput.vue'
  import {sortAsc} from '../../../utils/sorting'
  import ArenasTree from './ArenasTree.vue'

  export default {
    name: 'ChoseArenaForm',
    components: {ArenasTree, Loader, FilterInput},
    props: ['arenas', 'areArenasLoading'],
    data () {
      return {
        filteredArenas: [], // used to show arenas
        filterFields: ['name', 'domain', 'partner.name']
      }
    },
    watch: {
      arenas: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.onFilterArenas(newValue)
        }
      }
    },
    methods: {
      onChooseArena: function (arena) {
        this.$emit('choseArena', arena)
      },
      onFilterArenas: function (arenas) {
        this.filteredArenas = sortAsc(arenas, 'name')
      }
    }
  }
</script>
<style scoped lang="scss">
  .arena-list-container {
    height: calc(100vh - 329px);
    overflow: auto;
    min-height: 400px;
  }
</style>
